/* RESPONSIBLE TEAM: team-workflows */
import Model, { attr } from '@ember-data/model';

export default class OperatorBotInboxSettingsModel extends Model {
  @attr('boolean') assignConversationsToBots;
  @attr('boolean') deferSlas;
  @attr('date') assignConversationsToBotsLastEnabledAt;
}
